import { useSelector } from 'react-redux';
import { Account, AccountHolder } from 'src/models';
import { Maybe, RequiredExcept } from 'src/utils';

interface UseAccountSelectorReturnType {
  account?: Account;
  isAccountLoading: boolean;
  hasAccountError: boolean;
  accountError?: string;
  hasAccountSucceeded: boolean;
}

export const useAccountSelector = (): UseAccountSelectorReturnType => {
  const account: Maybe<Account> = useSelector((state: any) => state.accounts.item?.data);
  const isAccountLoading = useSelector((state: any) => Boolean(state.accounts.item?.__requested));
  const hasAccountError = useSelector((state: any) => Boolean(state.accounts.item?.__failed));
  const accountError = useSelector((state: any) => state.accounts?.item?.__message);
  const hasAccountSucceeded = useSelector((state: any) => Boolean(state.accounts.item?.__succeeded));

  return {
    account,
    isAccountLoading,
    hasAccountError,
    accountError,
    hasAccountSucceeded,
  };
};

type SubmittedAccount = Omit<Account, 'accountId' | 'primaryAccountHolder' | 'isAccredited'> & {
  accountId: NonNullable<Account['accountId']>;
  primaryAccountHolder: RequiredExcept<AccountHolder, 'trustedContact' | 'jointTenantsInCommonInterestPercent'>;
  isAccredited: NonNullable<Account['isAccredited']>;
};

interface UseSubmittedAccountSelectorReturnType {
  account: SubmittedAccount;
  isAccountLoading: boolean;
  hasAccountError: boolean;
  accountError?: string;
  hasAccountSucceeded: boolean;
}

export const useSubmittedAccountSelector = (): UseSubmittedAccountSelectorReturnType => {
  const account: SubmittedAccount = useSelector((state: any) => state.accounts.item.data);
  const isAccountLoading = useSelector((state: any) => Boolean(state.accounts.item.__requested));
  const hasAccountError = useSelector((state: any) => Boolean(state.accounts.item.__failed));
  const accountError = useSelector((state: any) => state.accounts.item?.__message);
  const hasAccountSucceeded = useSelector((state: any) => Boolean(state.accounts.item.__succeeded));

  return {
    account,
    isAccountLoading,
    hasAccountError,
    accountError,
    hasAccountSucceeded,
  };
};
